import { render, staticRenderFns } from "./exercise-item.vue?vue&type=template&id=4da54e42&"
import script from "./exercise-item.vue?vue&type=script&lang=js&"
export * from "./exercise-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports